import * as React from "react";
import {
  Bar,
  XAxis,
  YAxis,
  BarChart,
  Legend,
  Cell,
  LabelList,
  ResponsiveContainer,
} from "recharts";

const BarChartHorizontalComp = ({ bar1Key, barChartData, label, peerLabel, barWidth = 50, showLabels = true }) => {
  // Hide labels if no label is provided or if showLabels is false
  const shouldShowLabels = showLabels && label && label.trim() !== "";
  const colors = ["#025DC7", "#F1646C"];

  // ✅ Clean data labels before rendering
  const formattedData = barChartData.map((item) => {
    if (item.name === "Avg" || item.name.includes("People")) {
      return { ...item, displayName: peerLabel || "Peers (avg)" };
    }
    return { ...item, displayName: item.name };
  });

  // Calculate proper margins based on bar width
  const isThinBars = barWidth <= 35;
  const topMargin = isThinBars ? 50 : 40;
  const bottomMargin = isThinBars ? 50 : 40;

  return (
    <div style={{ 
      width: "100%", 
      height: "250px", 
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 10px"
    }}>
      <div style={{
        width: "100%",
        maxWidth: isThinBars ? "350px" : "500px",
        height: "100%"
      }}>
        <BarChart
          width={isThinBars ? 350 : 500}
          height={250}
          data={formattedData}
          layout="horizontal"
          margin={{ top: topMargin, right: 20, left: 20, bottom: bottomMargin + 10 }}
          barCategoryGap="20%"
        >
          <XAxis
            type="category"
            dataKey="displayName"   // ✅ Use formatted clean labels
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: "clamp(10px, 1.5vw, 14px)" }}
          />
          <YAxis
            type="number"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: "clamp(10px, 1.5vw, 14px)" }}
            domain={[0, (dataMax) => Math.ceil(dataMax)]}
          />
          <Legend
            payload={[
              { value: "You", type: "square", color: "#025DC7", id: "1" },
              {
                value: peerLabel || "People your age, on average",
                type: "square",
                color: "#F1646C",
                id: "2",
              },
            ]}
            wrapperStyle={{ fontSize: "clamp(10px, 1.5vw, 14px)" }}
          />
          <Bar 
            dataKey={bar1Key} 
            radius={[4, 4, 0, 0]} 
            minPointSize={3}
            maxBarSize={isThinBars ? 20 : 50}
            barGap="5%"
          >
            {formattedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
            {shouldShowLabels && (
              <LabelList
                dataKey="value"
                position="top"
                fill="#333"
                style={{ fontSize: "clamp(10px, 1.5vw, 14px)" }}
                offset={15}
              />
            )}
          </Bar>
        </BarChart>
      </div>
    </div>
  );
};

export default BarChartHorizontalComp;
